/** @prettier */

import createReducer from './createReducer';
import {
  FETCH_SESSIONS_CLIP,
  FETCH_SESSIONS_CLIP_FAILURE,
  FETCH_SESSIONS_CLIP_SUCCESS,
} from '../actions/sessions';

const initialState = {
  session: null,
  loading: false,
  error: null,
};

const handlers = {};

handlers[FETCH_SESSIONS_CLIP] = (state) => ({
  ...state,
  loading: true,
});

handlers[FETCH_SESSIONS_CLIP_SUCCESS] = (state, { session }) => ({
  ...state,
  session,
  loading: false,
});

handlers[FETCH_SESSIONS_CLIP_FAILURE] = (state, { error }) => ({
  ...state,
  session: null,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);
